import React from 'react';

const EditContact = React.lazy(() => import('./EditContact'));
const CreateContact = React.lazy(() => import('./CreateContact'));
const Contacts = React.lazy(() => import('./Contacts'));

export { EditContact, CreateContact, Contacts };
